import React, {useContext, useEffect, useState} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PayPalForm from "../components/PayPalForm";
import SuccessModal from "../components/SuccessModal";
import { AuthContext } from "../context/AuthContext";
import { IoArrowBackSharp } from "react-icons/io5";
import axiosInstance from "../utils/axiosInstance";
import Loader from "../components/Loader";

const BuyCredits = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const myBooleanParam = queryParams.get("success") === "true";
  const [loading, setLoading] = useState(true);
  const [uploaderText, setUploaderText] = useState(null)

  useEffect(() => {
    if (myBooleanParam) {
      const timer = setTimeout(() => {
        navigate("/my-files");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [myBooleanParam, navigate]);

  useEffect(() => {
    const fetchUploaderText = async () => {
      try {
        const response = await axiosInstance.get("/application-configuration");
        const uploaderText = response.data.uploader_text;
        if (uploaderText !== null && uploaderText !== "") {
          setUploaderText(uploaderText);
        }
      } catch (error) {
        console.error("Failed to fetch banner text", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUploaderText();
  }, []);

  if (uploaderText) {
    return (
        <div className="container mx-auto p-4">
          <div className="p-6 bg-white dark:bg-gray-800 border-md shadow-sm">
            <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-gray-100 flex items-center">
              <button
                  onClick={() => window.history.back()}
                  className="rounded-full hover:bg-gray-200 transition-all mr-2"
              >
                <IoArrowBackSharp size={24} />
              </button>{" "}
              Buy Credits
            </h3>
            <div className="flex items-start gap-4 p-4 bg-white dark:bg-gray-900 shadow-md rounded-lg border border-gray-200 dark:border-gray-700 mb-2">
              <div className="text-yellow-500 dark:text-yellow-400">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                  <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 16h-1v-4h-.01M12 8h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9.03 9 9 9z"
                  />
                </svg>
              </div>
              <div>
                <p className="text-gray-800 dark:text-gray-200 italic">
                  {uploaderText}
                </p>
              </div>
            </div>
          </div>
        </div>
    );
  }

  if (loading) {
    return (
        <div className="container mx-auto p-6">
          <Loader />
        </div>
    );
  }

  return (
    <div>
      <div className="flex items-start gap-4 p-4 bg-white dark:bg-gray-900 shadow-md rounded-lg border border-gray-200 dark:border-gray-700 mb-4">
        <div className="text-yellow-500 dark:text-yellow-400">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 16h-1v-4h-.01M12 8h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9.03 9 9 9z"
            />
          </svg>
        </div>
        <div>
          <p className="text-gray-800 dark:text-gray-200 italic">
            Thank you for trusting <strong>VDP Tuning!</strong> Your payment
            will be securely processed via PayPal, and credits will
            automatically be converted into CRS and added to your VDP Tuning
            account.
          </p>
        </div>
      </div>
      <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-gray-100 flex items-center">
        {/* Go Back Button */}
        <button
          onClick={() => window.history.back()} // This will navigate back to the previous page
          className="rounded-full hover:bg-gray-200 transition-all mr-2"
        >
          <IoArrowBackSharp size={24} />
        </button>{" "}
        Buy Credits
      </h3>
      <div className="max-w-md mt-8 mx-auto bg-gray-100 dark:bg-gray-600 text-gray-900 dark:text-gray-200 rounded text-center mb-8">
        {myBooleanParam ? (
          <SuccessModal message={"You bought credits successfully"} />
        ) : (
          <div className="py-8">
            <strong className="text-2xl">1 CRD = 1 EUR</strong>
            <h2 className="text-2xl mb-4">Buy Credits</h2>
            <PayPalForm userId={user.id} />
          </div>
        )}
      </div>
    </div>
  );
};

export default BuyCredits;
